import { PluginDefinition } from 'yam-types'
import { Go } from './wasm_exec'

declare const global: { [prop: string]: unknown }

type Plugin = Omit<Pick<PluginDefinition<unknown>, 'name' | 'version' | 'handlers'>, 'name' | 'version'>

export async function loadPlugin(wasmFile: Buffer): Promise<Plugin> {
  const go = new Go()
  const exportPromise =
    new Promise<PluginDefinition<unknown>>(resolve =>
      global['__go_wasm_export_plugin_resolve'] = resolve)

  const wasm = await WebAssembly.instantiate(wasmFile, go.importObject)
  go.run(wasm.instance)
  return exportPromise
}
